import React from 'react'

export default function Datanotfound() {
  return (
    <>
      <center><p>Data Not Available</p></center>
    </>
  )
}
